var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      class: [
        _vm.loading ? "screen-loading" : "",
        _vm.$vuetify.breakpoint.lgAndUp ? "" : "pt-0"
      ],
      attrs: {
        fluid: !_vm.loading,
        "grid-list-lg": !_vm.loading,
        "fill-height": ""
      }
    },
    [
      !_vm.loading
        ? [
            _c(
              "v-layout",
              { attrs: { wrap: "", "justify-center": "" } },
              [
                _c(
                  "v-flex",
                  {
                    staticClass: "pt-0",
                    attrs: { xs12: "", sm12: "", md8: "" }
                  },
                  [
                    _vm.isMobile && _vm.benefits_requested
                      ? _c("mobile-summary")
                      : _vm._e(),
                    _vm._v(" "),
                    _c("stepper"),
                    _vm._v(" "),
                    _vm.isMobile && _vm.current_step == 2
                      ? _c("mobile-bottom")
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isMobile,
                        expression: "!isMobile"
                      }
                    ],
                    staticClass: "pt-0",
                    attrs: { xs12: "", sm12: "", md4: "" }
                  },
                  [_c("side-menu")],
                  1
                )
              ],
              1
            )
          ]
        : _c(
            "v-layout",
            { attrs: { "justify-center": "", "align-center": "", column: "" } },
            [
              _c("v-progress-circular", {
                attrs: { size: 50, color: "secondary", indeterminate: "" }
              })
            ],
            1
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }